import cc from "classcat"

const H2 = ({
  children,
  className = "",
  textAlign = "",
  theme = "",
  size = "lg",
}) => (
  <h2
    className={cc([
      "m-0 font-extrabold leading-9 tracking-tight lg:whitespace-pre-line",
      className,
      {
        "text-left": textAlign === "left",
        "text-center": textAlign === "center",
        "text-right": textAlign === "right",
        "mb-6 text-4xl md:text-4xl lg:text-5xl xl:text-6xl": size === "xl",
        "mb-2 text-4xl md:text-3xl lg:text-4xl xl:text-5xl xl:leading-[1.15]":
          size === "lg",
        "mb-2 text-xl md:text-2xl lg:text-3xl xl:text-4xl": size === "md",
      },
      ["dark", "black", "darkyellow"].includes(theme)
        ? "text-zinc-100"
        : "text-neutral-800",
    ])}
  >
    {children}
  </h2>
)

export default H2
